'use es6';

import { usageTracker as defaultUsageTracker } from './usageTracker';
export const trackCsatSurveyRender = ({
  itemId,
  itemName
}) => {
  defaultUsageTracker.track('Cem', 'In Moment Survey Rendered', {
    itemId,
    itemName,
    itemType: 'csat'
  });
};
export const trackCesSurveyRender = ({
  itemId,
  itemName,
  usageTracker
}) => {
  (usageTracker || defaultUsageTracker).track('Cem', 'In Moment Survey Rendered', {
    itemId,
    itemName,
    itemType: 'ces'
  });
};
export const trackNpsSurveyRender = () => {
  defaultUsageTracker.track('Cem', 'In Moment Survey Rendered', {
    itemType: 'nps'
  });
};